import Config from 'services/config/config';
import callWebService, {callTypes} from 'services/utils/networks/network';
import { getProfile } from 'services/redux/auth/login/action';
import {
    CREATE_TASK,
    GET_CITIES,
    SITE_DETAILS,
    SITE_VISIT_BY_ID,
    SITE_VISIT_LIST,
    SITE_VISIT_TASK,
    TASK_LIST,
    SUB_HARDWARE_DROPDOWN,
    RM_CHECK_OUT
} from './type';

/**
 *
 * @returns {(function(*): Promise<*|undefined>)|*}
 */
export const getCitiesList = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.installation.getCitiesList}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: GET_CITIES, payload: data.response.data});
        return data;
    }
};

/**
 *
 * @param city_id
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const siteByCity = (data) => async (dispatch) => {
    dispatch({
        type: SITE_DETAILS,
        payload: null,
    });
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.installation.getSitesByCityId}?is_another=${true}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: SITE_DETAILS,
            payload: data,
        });
        return true;
    }
};

export const subHardwareDropdown = (id) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.installation.getSubHardwareDropDown}?parent_id=${id}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: SUB_HARDWARE_DROPDOWN, payload: data.response });
      return true;
    }
  };

/**
 *
 * @param data
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const createTask = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.networkEngineer.createTask}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: CREATE_TASK,
            payload: data,
        });
        return true;
    }
};

/**
 * @returns {(function(*): Promise<*|undefined>)|*}
 */
export const getList = (filterData = null, page = 1) => async (dispatch) => {
    let url = `${Config.networkEngineer.taskList}?page=${page}`
    if (filterData != null) {
        url = `${Config.networkEngineer.taskList}?page=${page}&client_name=${filterData?.client_name}&eng_name=${filterData?.eng_name}&from_date=${filterData?.from_date}&to_date=${filterData?.to_date}`
    }

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
        const {data} = res;
        dispatch({type: TASK_LIST, payload: data.response.data});
        return data;
    }
};


export const createSiteVisit = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.siteVisit.createTask}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: SITE_VISIT_TASK,
            payload: data,
        });
        return true;
    }
};

export const getSiteVisitList = (filterData = null, page = 1) => async (dispatch) => {
    let url = `${Config.siteVisit.taskList}?page=${page}`
    if (filterData != null) {
        url = `${Config.siteVisit.taskList}?page=${page}&client_name=${filterData?.client_name}&eng_name=${filterData?.eng_name}&from_date=${filterData?.from_date}&to_date=${filterData?.to_date}`
    }

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
        const {data} = res;
        dispatch({type: SITE_VISIT_LIST, payload: data.response.data});
        return data;
    }
};


export const siteVisitById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.siteVisit.getById}?id=${id}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: SITE_VISIT_BY_ID,
            payload: data?.response,
        });
        return true;
    }
};

export const rmCheckOutRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.maintenance.rmCheckOut}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: RM_CHECK_OUT,
            payload: data,
        });
        // Laravel: response.data === true; Go: status === 0
        if (data?.status === 0 || data?.response?.data === true) {
            dispatch(getProfile());
            return { ...res, success: true };
        }
        return res;
    }
};